import type { WrapProps } from '@leafwell/components';
import type { Page } from 'types/page';
import React, { useState } from 'react';
import Image from 'next/image';
import { Paragraph, Wrap } from '@leafwell/components';
import HeadingBody from 'components/heading-body';
import SignupForm from 'components/signup-form';
import WysiwygContent from './wysiwyg-content';

const HeroCannabisGuidance: React.FC<
  Partial<Pick<WrapProps, 'className' | 'spacer'>> &
    Pick<Page['acf'], 'hero' | 'pageType' | 'redirectCannabisCounseling'>
> = ({
  hero,
  pageType = 'cannabis_counseling',
  redirectCannabisCounseling,
  className = '',
  spacer = true,
}) => {
  const [activeTab, setActiveTab] = useState<'new' | 'renew'>('new');
  return (
    <Wrap
      className={[
        'grid lg:grid-cols-2 lg:gap-x-16 items-start',
        className,
      ].join(' ')}
      spacer={spacer}
      tagName="header"
    >
      <div className="grid gap-y-6">
        <HeadingBody
          level="5"
          tagName="p"
          title={hero.subTitle}
          className="hidden lg:block"
        />
        <HeadingBody level="1" title={hero.title} className="font-semibold" />
        {hero.description && (
          <WysiwygContent
            content={hero.description}
            className="!text-lg xl:!text-xl"
          />
        )}
        {hero.badges?.length > 0 && (
          <div className="grid xl:flex gap-x-8 xl:mt-32">
            {hero.badges.map(({ label, icon }, idx) => (
              <article
                key={`badge-${idx}`}
                className="flex gap-x-2 items-center justify-start mt-2 xl:flex-col xl:border xl:rounded-2xl xl:border-white xl:bg-white xl:p-6 xl:gap-6 xl:w-48 xl:justify-items-center xl:mt-0"
              >
                {icon && (
                  <Image
                    src={icon.src}
                    className="w-5 xl:w-auto"
                    alt={icon.alt}
                    width={icon.width}
                    height={icon.height}
                  />
                )}
                <Paragraph className="text-center text-sm xl:text-lg">
                  {label}
                </Paragraph>
              </article>
            ))}
          </div>
        )}
      </div>
      <div className="w-full justify-self-center">
        <SignupForm
          pageType={pageType}
          redirectMedicalCard={false}
          redirectCannabisCounseling={redirectCannabisCounseling}
          formSubmitText={hero.formSubmitText}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </Wrap>
  );
};

export default HeroCannabisGuidance;
